import { Component, Input, OnChanges } from '@angular/core';
import { ApiService } from 'src/app/api/api.service';

// Lists the files "Add all task files to secure email?" will attach. Mirrors the backend's rule
// (Files.GetAllFilesInDirectory, called by each send in Steps.cs): files directly in the task's folder
// (the folder whose guid is the task guid - subfolders aren't included) that are visible to both the
// team and the client. The files are gathered when the action is sent, so this is a current snapshot.
@Component({
  selector: 'app-task-email-files',
  templateUrl: './task-email-files.component.html',
})
export class TaskEmailFilesComponent implements OnChanges {
  @Input() task_guid: string;

  files: any[] = [];
  loading = false;

  constructor(private apiService: ApiService) { }

  ngOnChanges() {
    void this.GetFiles();
  }

  async GetFiles() {
    this.files = [];
    if (!this.task_guid) return;
    const guid = this.task_guid;
    this.loading = true;
    const data: any = await this.apiService.get(`files/${guid}`);
    if (guid !== this.task_guid) return; // A newer task_guid's request has taken over
    // A task with no folder yet (e.g. not saved) comes back unsuccessful - that just means no files.
    const isOn = (value: any) => value === true || value == 1;
    const items = (data?.success && Array.isArray(data.data)) ? data.data : [];
    this.files = items.filter((f: any) => isOn(f.is_file) && isOn(f.visible_to_client));
    this.loading = false;
  }
}
